import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root',
})
export class CondicionPagoService {
  constructor(private gqlclient: GraphQLClient) {}

  Get(rut_empresa, sucursal_codigo, callback: Function) {
    const inputParams = this.createInputParams(rut_empresa, sucursal_codigo);
    this.executeQuery(inputParams, callback);
  }

  // FV: Lo hago a modo de limpiar la data de parámetros innecesarios y para direccionar la query en pro del contexto
  private createInputParams(rut_empresa, sucursal_codigo) {
    return {
      rut_empresa,
      sucursal_codigo,
    };
  }

  private executeQuery(inputParams: any, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($rut_empresa: Decimal, $sucursal_codigo: Decimal) {
            condicion_pago {
              obtenerSegunFiltro(filtro: { exacto: { rut_empresa: $rut_empresa, sucursal_codigo: $sucursal_codigo } }) {
                respuesta {
                  registros {
                    codigo
                    descripcion
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { respuesta } = response.data.condicion_pago.obtenerSegunFiltro;
        if (!respuesta) {
          callback(null);
          return;
        }

        const { registros } = respuesta;
        callback({ registros });
      }
    );
  }

  public obtenerSegunFiltro(
    inputParams: {
      rut_empresa: number;
      sucursal_codigo: number;
      tipobusqueda: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($rut_empresa: Decimal, $sucursal_codigo: Decimal, $tipobusqueda: Int) {
            condicion_pago {
              obtenerSegunFiltro(filtro: { exacto: { rut_empresa: $rut_empresa, sucursal_codigo: $sucursal_codigo, tipobusqueda: $tipobusqueda } }) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    codigo
                    rut_empresa
                    sucursal_codigo
                    descripcion
                    cantidad_dias
                    uso_venta
                    uso_compra
                    estado
                    recargoporc
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.condicion_pago.obtenerSegunFiltro;
        callback({ mensajes, respuesta });
      }
    );
  }

  public obtenerCondicionPagoCompra(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: condicion_pagoInputType) {
            condicion_pago {
              obtenerCondicionPagoCompra(entidad: $entidad) {
                respuesta {
                  registros {
                    rut_empresa
                    sucursal_codigo
                    codigo
                    descripcion
                    cantidad_dias
                    estado
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.condicion_pago.obtenerCondicionPagoCompra;
        callback({ mensajes, respuesta });
      }
    );
  }

  public obtenerSegunId(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: condicion_pagoInputType) {
            condicion_pago {
              obtenerSegunId(entidad: $entidad) {
                respuesta {
                  descripcion
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.condicion_pago.obtenerSegunId;
        callback({ mensajes, respuesta });
      }
    );
  }
}
